import axios from 'axios'
import Socket from '../../classes/WebSocket'
import Global from '../Global'
import { Logging } from '../Logging'
import UserApi from './user.api'

export let sessionId = Global.getSessionID()
export let sessionHeader = null
const SESSION_RENEW_TIME = 60 * 60 * 1000; // One hour

let user_cp_ids = []
let post_id = ''

export let salt = function(){
  var ID = ""
  var odds = "0123456789ABCDEF"
  for(var i=0;i < 32;i++){
    ID += odds.charAt(Math.floor(Math.random() * odds.length))
  }
  return ID
}

axios.defaults.headers.common['is-cp-api'] = true;
// axios.defaults.headers.common['content-type'] = 'application/json';

export default class MainApi {
  /** API load when user Loggedin first time */
    static onLoad(){
        sessionId = Global.getSessionIdCookie()
        Logging.Debug(sessionId)

      setTimeout(MainApi.RenewSession, SESSION_RENEW_TIME)
        sessionHeader = {
            headers:{
              "session_id": sessionId,
            }
        }
        sessionStorage.setItem('sessionHeader', sessionHeader)
    }

    static authenticate(email = '', pw = '', token = ''){
      let data = {}
      if(token.length == 0){
         data = {
          'email': email,
          'pw':  pw,
          'session_duration': 86400
        }
      }else {
        data = {
          'token_id': token,
          'session_duration': 86400
        }
      }
        return axios
        .post(Global.GetAPIURL() + '/user/login', JSON.stringify(data))
    }

    static RefreshUI(session_id){
      return axios
      .post(Global.GetAPIURL() + '/cpadmin/refresh_sessions_ui',JSON.stringify({}),{
        headers:{
          "session_id": session_id
        }
      }).catch(function(err) {
       if(typeof err.response != "undefined" && err.response.status == 401){
            Global.logout()
            sessionStorage.setItem("invalid_session_id", true)
        }
    })
    }

    static socketSetup(){
        Socket.init();
        Socket.Notify({"session_id": sessionId});
        Socket.heartbeat();
    }

    static RenewSession(){
      /**RenewSession*/
      Logging.Info("Renewing Session ID")
      UserApi.UpdateSession()
      setTimeout(MainApi.RenewSession,  SESSION_RENEW_TIME)
    }

    static setHeader(id=null){
      if(id != null){
        sessionHeader = {
          headers:{
            "session_id": id,
          }
        }
      }else {
        sessionHeader = {
          headers:{
            "session_id": Global.getSessionID(),
          }
        }
      }
      sessionStorage.setItem('sessionHeader', sessionHeader)
  }

  static getHeader(){
    return sessionHeader
  }
}
